import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormChunkUpload,
  title: 'Chunk Upload',
  category: ComponentCategory.FormControls,
};
